<template>
    <v-menu offset-y dark>
        <template v-slot:activator="{ on }">
            <v-btn tile class="toolbar-btn" text dark small v-on="on" height="48px">
                <v-icon small>menu</v-icon>
            </v-btn>
        </template>
        <v-list tile small class="py-0" :color="$vuetify.theme.themes.dark.primary" id="list">
            <v-list-item class="text-center small" v-for="item in getNavigationItems" :key="item.to" :to="item.to">
                {{ $t(item.title) }}
            </v-list-item>
            <v-list-item class="text-center small" to="/profile">{{ $t('Профиль') }}</v-list-item>
            <v-list-item class="text-center small" @click="logoutFromApplication">
                {{ $t('Выйти') }}
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters('base', ['getNavigationItems'])
    },
    methods: {
        ...mapActions('auth', ['logout']),
        async logoutFromApplication() {
            let response = await this.logout();
        }
    }
};
</script>

<style lang="scss" scoped>
.small {
    font-size: 10px;
    line-height: 12px;
    padding: 0 8px;
    min-height: 30px;
    align-items: center;
}
</style>
